import { render } from "./ThePanelProfile.vue?vue&type=template&id=30df654e&scoped=true"
import script from "./ThePanelProfile.vue?vue&type=script&lang=js"
export * from "./ThePanelProfile.vue?vue&type=script&lang=js"

import "./ThePanelProfile.vue?vue&type=style&index=0&id=30df654e&scoped=true&lang=css"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30df654e"]])